<template>
    <div>
        <StudentManage class="my-3" :can-edit-state="true" :can-reset-password="true" :college-id="collegeId"></StudentManage>
    </div>
</template>

<script>
import StudentManage from "@/components/user/StudentManage";
export default {
    name: "CollegeStudentManage",
    components: {StudentManage},
    data: function () {
        return {
            collegeId: this.$store.state.userInfo.userId,
        };
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>

</style>